<template>
  <Layout>
    <router-view />
  </Layout>
  <CookieConsent />
  <ChatWidget />
</template>

<script setup lang="ts">
import Layout from "./layouts/Layout.vue";
import CookieConsent from "@/components/CookieConsent.vue";
import ChatWidget from "@/components/ChatWidget.vue";
import { useHead } from '@vueuse/head';
import { useI18n } from 'vue-i18n';
import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';

const { locale } = useI18n();
const route = useRoute();

// 支持的语言列表
const supportedLocales = ['en', 'pl', 'it', 'vn'];

// 动态生成 hreflang 标签
const hreflangLinks = computed(() => {
  const baseUrl = 'https://www.creston-group.com';
  const currentPath = route.path;

  // 生成各语言版本的链接
  const links = supportedLocales.map(lang => ({
    rel: 'alternate',
    hreflang: lang === 'en' ? 'en' : lang === 'vn' ? 'vi' : lang,
    href: `${baseUrl}${currentPath}${currentPath.includes('?') ? '&' : '?'}lang=${lang}`
  }));

  // 添加 x-default (默认为英语)
  links.push({
    rel: 'alternate',
    hreflang: 'x-default',
    href: `${baseUrl}${currentPath}`
  });

  return links;
});

// 根据当前语言设置 html lang 属性
const htmlLang = computed(() => {
  const langMap: Record<string, string> = {
    'en': 'en',
    'pl': 'pl',
    'it': 'it',
    'vn': 'vi'
  };
  return langMap[locale.value] || 'en';
});

useHead({
  htmlAttrs: {
    lang: htmlLang
  },
  link: hreflangLinks
});
</script>